<template>
    <v-expansion-panel>
        <v-expansion-panel-content
            v-for="(item,i) in faq"
            :key="i"
        >
            <template v-slot:header>
                <div v-html="item.question" class="question-text"></div>
            </template>
            <v-card>
                <v-card-text v-html="item.answer"></v-card-text>
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
    export default {
        props: ['faq']
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/elements/Questions.vue